import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Listings } from 'containers/AppContainer/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import ProcedureInformation from 'containers/LawyerLegalProceedingsPage/judgementAdd/ProcedureInformation';
import { get } from 'lodash';
import AppealAddPronouncing from 'containers/LawyerLegalProceedingsPage/AppealAdd/AppealAddPronouncing';
export interface AppealAddFormProps {
  intl: IntlShape;
  listings: Listings;
  policyInfo: any;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  procedureInstance: any;
  victims?: any;
  vehicules?: any;
  setDocument?: Function;
  document?: any;
  setProcedureInstance: Function;
  details: any;
  setDetails: Function;
  civilPartyDocuments: any;
  setCivilPartyDocuments: Function;
  judgementAddDocuments: any;
  setJudgementAddDocuments: Function;
  disabled: boolean;
  processInformationValidation: any;
  messageError: any;
  canStartCivilParty: boolean;
  requestGetDocByDocumentumId: Function;
}

export const AppealAddForm: React.FC<AppealAddFormProps> = (
  props,
): JSX.Element => {
  return (
    <>
      <ProcedureInformation
        listings={props.listings}
        details={props.details}
        vehicules={props.vehicules}
        setDetails={props.setDetails}
        processInformationValidation={props.processInformationValidation}
        messageError={props.messageError}
        lossDate={get(props.policyInfo, 'sagisInfoClaim.lossDate', '')}
        sagisOpposingParties={null}
        currentJudiciaryProcess={props.procedureInstance}
      />
      <AppealAddPronouncing
        judgementAddDocuments={props.judgementAddDocuments}
        setJudgementAddDocuments={props.setJudgementAddDocuments}
        listings={props.listings}
        document={props.document as any}
        setDocument={props.setDocument as any}
        victims={props.victims}
        details={props.details}
        vehicules={props.vehicules}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        resetUploadedDocument={props.resetUploadDocumentStore}
        disabled={props.disabled}
        sagisVictimInfo={null}
        sagisOpposingParties={null}
        setOpenFeeNoteDialog={() => {}}
        imagineDocuments={[]}
        claimId={(null as unknown) as number}
        policyInfo={{}}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
    </>
  );
};

export default injectIntl(AppealAddForm);
